<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <loading-component>
        <template #content>
            <div class="flex flex-col gap-4 xl:mx-60">
                <div class="flex flex-row items-center gap-4">
                    <back-component></back-component>
                    <span class="text-2xl font-bold text-secondary">Claim erstellen</span>
                </div>

                <upsert-claim-component v-model="claim" @save="create" />
            </div>
        </template>
    </loading-component>
</template>

<script>
import BackComponent from '@/components/BackComponent';
import UpsertClaimComponent from '@/components/claims/UpsertClaimComponent';
import LoadingComponent from '@/components/LoadingComponent';
import { mapStores } from 'pinia';
import { useClaimsStore } from '@/stores/claims';
import Notifications from '@auth/vue-share/utility/notifications';
import logger from '@auth/vue-share/utility/logger';
import FieldUtility from '@/utility/field.utility';

export default {
    name: 'CreateClaimView',
    components: { LoadingComponent, UpsertClaimComponent, BackComponent },
    data() {
        return {
            claim: {
                identifier: undefined,
                name: undefined,
                description: undefined
            }
        };
    },
    computed: {
        ...mapStores(useClaimsStore)
    },
    methods: {
        create(claim) {
            if (FieldUtility.isNull(['identifier', 'name'], claim)) return;

            this.claimsStore
                .createClaim(claim)
                .then((response) => {
                    Notifications.success('Claim erfolgreich erstellt');
                    this.$router.push(`/claims/${response.data.data.identifier}`);
                })
                .catch((error) => {
                    Notifications.error('Der Claim konnte nicht erstellt werden');
                    logger.error('[CLAIM]', error);
                });
        }
    }
};
</script>

<style scoped></style>
